import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { ValList } from '@/common/val/ValList';
import { McoDispList } from '../mcoDisp/McoDispList';

export const McoInvLineDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'disps', label: 'Disputes', content: <McoDispList mcoInvLineId={entityObj.id} partition={entityObj.invPeriodCode} />},
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="MCO_INV_LINE" parentEntityId={entityObj.id} /> }
  ];

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}